import CoreAndCatchUpListView from './component';
import { TABS, LESSON_CATEGORY } from '../routes';

export default () => ({
  path: `${TABS[LESSON_CATEGORY.CORE_CATCH_UP]}`,
  component: CoreAndCatchUpListView,
});



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/CoreAndCatchUp/routes.js